import React, { Component } from "react";
import dot from "../../../../assets/logos/dot_horizontal.svg";
import playlist from "../../../../assets/images/2.png";
import chevron from "../../../../assets/logos/chevron.svg";
import en from "../../../../locales/en/translation.json";
import fr from "../../../../locales/fr/translation.json";

export default class Creators extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      creators: this.props.creators,
      lang: "en",
      trad: en,
    };
  }
  componentDidMount() {
    if (JSON.parse(localStorage.getItem("user"))) {
      this.setState(
        {
          user: JSON.parse(localStorage.getItem("user")),
        },
        () => {
          let lang = this.state.user.user.language;
          if (lang === "fr") {
            this.setState({ lang: "fr", trad: fr });
          }
        }
      );
    }
  }

  handleOpenMenuDot = (index) => {
    let id = `menu_creators_${index}`;
    let menu = document.getElementById(id);
    if (menu.style.display === "block") {
      menu.style.display = "none";
    } else {
      menu.style.display = "block";
    }
  };
  handleCallBackLaunch = (type, action, index) => {
    console.log(type, action, index);
    if (action === "disliker") {
      this.handleDislike(type, action, index);
    } else {
      this.props.callBackEpingle(type, action, index);
    }
  };
  handleDislike = (type, action, index) => {
    console.log("dislike " + type, action, index);
  };

  render() {
    return (
      <div className="playlists creators">
        <h2>
          {this.state.trad.pDescriptionUtilisateur}{" "}
          <img style={{ marginLeft: "8px" }} src={chevron} alt="" />
        </h2>
        <div className="bloc_playlist">
          {this.state.creators.map((value, index) => (
            <div className={`playlist`} key={index}>
              <div className="menu">
                <img
                  onClick={() => this.handleOpenMenuDot(index)}
                  src={dot}
                  alt=""
                />
                <ul id={`menu_creators_${index}`}>
                  <li
                    onClick={() =>
                      this.handleCallBackLaunch("videos", "bug", index)
                    }
                  >
                    {this.state.trad.pDescriptionUtilisateur3}
                  </li>
                  <li
                    onClick={() =>
                      this.handleCallBackLaunch("videos", "contenu", index)
                    }
                  >
                    {this.state.trad.pDescriptionUtilisateur4}
                  </li>
                  <li
                    onClick={() =>
                      this.handleCallBackLaunch("videos", "disliker", index)
                    }
                  >
                    Disliker
                  </li>
                  {/*
                                            !this.state.myPage &&
                                            <>
                                                <li onClick={() => this.handleCallBackLaunch("videos", "save", index)}>{this.state.trad.pDescriptionUtilisateur5}</li>
                                            </>
                                        */}
                  <li
                    onClick={() =>
                      this.handleCallBackLaunch("videos", "share", index)
                    }
                  >
                    {this.state.trad.pDescriptionUtilisateur6}
                  </li>
                </ul>
              </div>
              <div className="img">
                <img
                  src={
                    value.image_place !== null
                      ? import.meta.env.VITE_BACKEND_URL_IMG +
                        value.perso.avatar
                      : playlist
                  }
                  alt=""
                />
              </div>
              <div className="text creatorsFav">
                <a href={`/page-de-profil/${value.id}`}>
                  <p>{value.nom_artiste}</p>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}
